import React from 'react';
import { connect } from 'react-redux';
import history from '../../history';
import { popupBot } from '../../actions';
import { dataBaseManager } from '../hupUtils/utils';
import { Form, Row, Col, Container, Button } from 'react-bootstrap';
import 'react-vertical-timeline-component/style.min.css';
import { VerticalTimelineElement, VerticalTimeline } from 'react-vertical-timeline-component';
//import 'react-vertical-timeline-component/style.min.css';

class pointWork extends React.Component {


    state = { point: null, tituloFase: null, detalleFase: null, inputFase: null }

    componentDidMount() {

        if (!this.props.userDetail) {
            history.push('/dashboard');
            return;
        }

        const nameRef2 = this.componentDatabase('get', `Usuario-Flujo-Trabajo/${this.props.userDetail.idUsuario}`);
        nameRef2.on('value', (snapshot2) => {
            if (snapshot2.val()) {
                const listaX = snapshot2.val().fases;
                this.setState({ inputFase: listaX });
            }
        });

    }
    componentDatabase(tipo, path, objectIn, mensaje, mensajeError) {
        let men = dataBaseManager(tipo, path, objectIn, mensaje, mensajeError);
        if (men && men.mensaje)
            this.props.popupBot({ mensaje: men.mensaje });
        return men;
    }

    renderguardarFase() {
        let listaX = this.state.inputFase;
        if (!listaX)
            listaX = [];
        const fases = Object.keys(listaX).length + 1;

        listaX.push({ titulo: this.state.tituloFase, detalle: this.state.detalleFase, id: fases });
        this.componentDatabase('insert', `Usuario-Flujo-Trabajo/${this.props.userDetail.idUsuario}`, {
            fechaCreado: new Date().toString(),
            cantidadFases: fases,
            fases: listaX,
        });
        this.setState({ tituloFase: "" });
        this.setState({ detalleFase: "" });
    }


    renderEliminarFase(ind) {

        const listaX = this.state.inputFase;
        listaX.splice(ind, 1);
        const fases = Object.keys(listaX).length + 1;
        this.componentDatabase('insert', `Usuario-Flujo-Trabajo/${this.props.userDetail.idUsuario}`, {
            fechaCreado: new Date().toString(),
            cantidadFases: fases,
            fases: listaX,
        });

    }

    renderCrearComponentInicial(nombre, titulo, detalle) {

        return <div style={{ height: '12em' }}>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: '#d45df2' }}
                date={nombre}
                iconStyle={{ background: '#ce11fe', color: '#fff', width: 'calc(6vh)', height: 'calc(6vh)' }}
                icon={

                    <Row>
                        <Col   >
                            <i className="material-icons md-18 icon_flow">follow_the_signs</i>
                        </Col>
                    </Row>

                }
            >
                <Row>
                    <Col xs={12}  >
                        <h3 className="vertical-timeline-element-title">{titulo}</h3>
                        <h6 className="vertical-timeline-element-subtitle">{detalle}</h6>
                    </Col>
                </Row>

                <Row>
                    <Col md={{ span: 1, offset: 10 }} xs={{ span: 1, offset: 9 }} onClick={() => { this.renderEliminarFase(0) }}  >
                        <i className="material-icons md-18">cancel</i>
                    </Col>
                </Row>
            </VerticalTimelineElement>



        </div>
            ;
    }

    renderCrearComponenteNormal(nombre, titulo, detalle, item) {

        return <div style={{ height: '12em' }}>
            <VerticalTimelineElement
                position={item % 2 === 1 ? "right" : "left"}
                className="vertical-timeline-element--work"
                date={nombre}

                iconStyle={{ background: '#ce11fe', color: '#fff', width: 'calc(6vh)', height: 'calc(6vh)' }}
                icon={


                    <Row>
                        <Col   >
                            <i className="material-icons md-18 icon_flow">follow_the_signs</i>
                        </Col>
                    </Row>

                }>
                <Row>
                    <Col xs={12}  >
                        <h3 className="vertical-timeline-element-title">{titulo}</h3>
                        <h6 className="vertical-timeline-element-subtitle">{detalle}</h6>
                    </Col>
                </Row>

                <Row>
                    <Col md={{ span: 1, offset: 11 }} xs={{ span: 1, offset: 9 }} onClick={() => { this.renderEliminarFase(item) }}  >
                        <i className="material-icons md-18">cancel</i>
                    </Col>
                </Row>
            </VerticalTimelineElement>


        </div>;
    }


    renderCrearFases() {

        let listaX = this.state.inputFase;
        if (!listaX)
            listaX = [];
        let mapFases = [];
        Object.keys(listaX).map((key, index) => {
            if (index === 0) {
                mapFases.push(this.renderCrearComponentInicial((index + 1) + " fase", listaX[key].titulo, listaX[key].detalle));
            }
            else {
                mapFases.push(this.renderCrearComponenteNormal((index + 1) + " fase", listaX[key].titulo, listaX[key].detalle, index));
            }
            return listaX[key];
        });
        mapFases.push(this.renderCrearComponenteFin());
        return mapFases;
    }

    renderCrearComponenteFin() {

        return <Row>
            <Col md={12} xs={8} >
                <VerticalTimelineElement

                    iconStyle={{ background: '#b5cc18', color: '#fff', width: 'calc(6vh)', height: 'calc(6vh)' }}
                    icon={


                        <i className="material-icons md-18 icon_flow">military_tech</i>

                    }
                />
            </Col>
        </Row>
    }

    render() {


        return (
            <Container >
                <Row>
                    <Col md={{ span: 10, offset: 1 }} xs={{ span: 12 }} className='flow_container' >
                        <Row>
                            <Col md={{ span: 8, offset: 3 }} xs={{ span: 12 }} >
                                <h3>El flujo de trabajo para tus objetivos</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col >
                                <VerticalTimeline>
                                    {this.renderCrearFases()}
                                </VerticalTimeline>
                            </Col>
                        </Row>

                        <Form className='fondo_form '>
                            <Form.Group controlId="ControlInput1">
                                <Form.Label>El nombre de la fase es</Form.Label>
                                <Form.Control name="codWorkSpace"
                                    type="text" value={this.state.tituloFase}
                                    onChange={e => this.setState({ tituloFase: e.target.value })}>
                                </Form.Control>
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId="ControlInput2">
                                <Form.Label>Una descripcion sencilla de esta fase es</Form.Label>
                                <Form.Control name="codWorkSpace"
                                    type="text" value={this.state.detalleFase}
                                    onChange={e => this.setState({ detalleFase: e.target.value })}>
                                </Form.Control>
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            </Form.Group>
                            <Row>
                                <Col md={{ span: 3, offset: 5}} xs={{ span: 8, offset: 2 }} >
                                    <Button style={{ background: 'bluex', borderRadius: '10px', top: '-3vh' }} disabled={!this.state.tituloFase} onClick={() => { this.renderguardarFase() }} >
                                        Agregar fase  <i className="material-icons md-18">add_task</i>
                                    </Button>
                                </Col>
                            </Row>
                        </Form>

                    </Col>
                </Row>
            </Container>


        );
    }

}

const mapStateToProps = (state) => {
    return {
        userDetail: state.mainReducer.userDetail,
    };
};

export default connect(mapStateToProps, { popupBot })(pointWork);